let NEW = 'new'
let OPEN = 'open'
let PENDING = 'pending'
let ONHOLD = 'onhold'
let CLOSED = 'closed'

export let MESSAGE_ACTIONS = {
  withMessage: {
    [NEW]: 'Send and Open',
    [OPEN]: 'Send and Open',
    [PENDING]: 'Send and Set To Pending',
    [ONHOLD]: 'Send and Put On Hold',
    [CLOSED]: 'Send and Close',
  },
  noMessage: {
    [NEW]: 'Open',
    [OPEN]: 'Open',
    [PENDING]: 'Set To Pending',
    [ONHOLD]: 'Put On Hold',
    [CLOSED]: 'Close',
  },
  tags: {
    [NEW]: 'New',
    [OPEN]: 'Open',
    [PENDING]: 'Pending',
    [ONHOLD]: 'On Hold',
    [CLOSED]: 'Close',
  },
}

export let THREAD_STATUS_ORDERED_WITH_INDEX = {
  [NEW]: 0,
  [OPEN]: 1,
  [PENDING]: 2,
  [ONHOLD]: 3,
  [CLOSED]: 4,
}

export let THREAD_STATUSES = {
  [NEW]: NEW,
  [OPEN]: OPEN,
  [PENDING]: PENDING,
  [ONHOLD]: ONHOLD,
  [CLOSED]: CLOSED,
}

export let THREAD_STATUS_ORDERED = [NEW, OPEN, PENDING, ONHOLD, CLOSED]

export let THREAD_STATUS_ORDERED_WITHOUT_NEW = [OPEN, PENDING, ONHOLD, CLOSED]

export let PRACTICE_HUB_FEATURE_FLAGS = [
  {
    key: 'patient.login.enabled',
    label: 'Practice Hub login',
    description: 'User is able to login onto the Practie Hub app',
    schema: { type: 'boolean', default: true },
  },
  {
    key: 'patient.appointments.cancel',
    label: 'Appointment cancellation',
    description: 'Patient is able to cancel appointments',
    schema: { type: 'boolean', default: true },
  },
  {
    key: 'patient.appointments.reschedule',
    label: 'Appointment rescheduling',
    description: 'Patient is able to reschedule appointments',
    schema: { type: 'boolean', default: true },
  },
  {
    key: 'patient.appointments.schedule',
    label: 'Appointment scheduling',
    description: 'Patient is able to schedule appointments',
    schema: { type: 'boolean', default: true },
  },
  {
    key: 'patient.comms.enabled',
    label: 'Communication features',
    description: 'Patient is able to use the message functionality',
    schema: { type: 'boolean', default: true },
  },
  {
    key: 'patient.payment_method.allowed',
    label: 'Select allowed payment methods on the Practice Hub',
    schema: {
      oneOf: [
        {
          const: 'credit_card',
          title: 'Credit Card only',
        },
        {
          const: 'ach',
          title: 'ACH only',
        },
        {
          const: 'credit_card_and_ach',
          title: 'Credit Card & ACH',
        },
        {
          const: 'payment_plan',
          title: 'Payment method on Payment Plan',
        },
      ],
      default: 'credit_card',
    },
  },
]

export let PAY_APP_FEATURE_FLAGS = [
  {
    key: 'pay_app.allow_update_of_payment_plan.enabled',
    label: 'Allow update of payment plan',
    description:
      'Payor is allowed to update their payment plan with the payment method used in the pay app request',
    schema: { type: 'boolean', default: false },
  },
  {
    key: 'pay_app.payment_method.allowed',
    label: 'Select allowed payment methods on the Pay App',
    schema: {
      oneOf: [
        {
          const: 'credit_card',
          title: 'Credit Card only',
        },
        {
          const: 'ach',
          title: 'ACH only',
        },
        {
          const: 'credit_card_and_ach',
          title: 'Credit Card & ACH',
        },
        {
          const: 'payment_plan',
          title: 'Payment method on Payment Plan',
        },
      ],
      default: 'credit_card',
    },
  },
]

export let AUDAX_CEPH_TRACING_FEATURE_FLAGS = [
  {
    key: 'audax.ceph.enabled',
    label: 'Enable Audax Ceph Integration',
    description: 'The audax ceph integration is enabled for the location',
  },
]

export let MEDICAL_FORM_NEW_APP_FEATURE_FLAGS = [
  {
    key: 'medical-form.v2.disable_insurance_questions',
    label: 'Disable insurance questions for the medical form',
    description:
      'The insurance questions for the new medical form app will be disabled',
  },
  {
    key: 'medical.form.v2.appointment.enabled',
    label:
      'Enable ability to schedule appointment directly after completion of the medical form',
    description:
      'The user can schedule an appointment as part of the medical form process',
  },
]

export let PATIENT_IMAGE_LAYOUT_DEFINITIONS = {
  standard_8: [
    [
      {
        type_key: 'ortho',
        slot_key: 'facialFrontal',
        rows: 3,
        columns: 3,
      },
      {
        type_key: 'ortho',
        slot_key: 'facialFrontalSmiling',
        rows: 3,
        columns: 3,
      },
      {
        type_key: 'ortho',
        slot_key: 'facialLateral',
        rows: 3,
        columns: 3,
      },
    ],
    [
      {
        type_key: 'ortho',
        slot_key: 'occlusalUpper',
        rows: 2,
        columns: 3,
      },
      {
        type_key: 'ortho',
        slot_key: 'logo',
        rows: 2,
        columns: 3,
      },
      {
        type_key: 'ortho',
        slot_key: 'occlusalLower',
        rows: 2,
        columns: 3,
      },
    ],
    [
      {
        type_key: 'ortho',
        slot_key: 'buccalRight',
        rows: 2,
        columns: 3,
      },
      {
        type_key: 'ortho',
        slot_key: 'buccalCenter',
        rows: 2,
        columns: 3,
      },
      {
        type_key: 'ortho',
        slot_key: 'buccalLeft',
        rows: 2,
        columns: 3,
      },
    ],
  ],
  standard_10: [
    [
      {
        type_key: 'ortho',
        slot_key: 'facialFrontal',
        rows: 3,
        columns: 3,
      },
      {
        type_key: 'ortho',
        slot_key: 'facialFrontalSmiling',
        rows: 3,
        columns: 3,
      },
      {
        type_key: 'ortho',
        slot_key: 'facialLateral',
        rows: 3,
        columns: 3,
      },
      {
        type_key: 'xRayCephalometric',
        slot_key: 'xRayCephalometric',
        rows: 5,
        columns: 5,
      },
    ],
    [
      {
        type_key: 'ortho',
        slot_key: 'occlusalUpper',
        rows: 2,
        columns: 3,
      },
      {
        type_key: 'ortho',
        slot_key: 'logo',
        rows: 2,
        columns: 3,
      },
      {
        type_key: 'ortho',
        slot_key: 'occlusalLower',
        rows: 2,
        columns: 3,
      },
    ],
    [
      {
        type_key: 'ortho',
        slot_key: 'buccalRight',
        rows: 2,
        columns: 3,
      },
      {
        type_key: 'ortho',
        slot_key: 'buccalCenter',
        rows: 2,
        columns: 3,
      },
      {
        type_key: 'ortho',
        slot_key: 'buccalLeft',
        rows: 2,
        columns: 3,
      },
      {
        type_key: 'xRayPanoramic',
        slot_key: 'xRayPanoramic',
        rows: 2,
        columns: 5,
      },
    ],
  ],
  x_ray_cephalometric: [
    [
      {
        type_key: 'xRayCephalometric',
        slot_key: 'xRayCephalometric',
        rows: 1,
        columns: 1,
      },
    ],
  ],
  x_ray_panoramic: [
    [
      {
        type_key: 'xRayPanoramic',
        slot_key: 'xRayPanoramic',
        rows: 2,
        columns: 5,
      },
    ],
  ],
}

export let PATIENT_IMAGE_NAMES = {
  buccalCenter: 'Buccal center',
  buccalLeft: 'Buccal left',
  buccalRight: 'Buccal right',
  facialFrontal: 'Facial frontal',
  facialFrontalSmiling: 'Facial frontal smiling',
  facialLateral: 'Facial lateral',
  occlusalLower: 'Occlusal lower',
  occlusalUpper: 'Occlusal upper',
  xRayCephalometric: 'X-Ray cephalometric',
  xRayMolarLeft: 'X-Ray molar left',
  xRayMolarPreLeft: 'X-Ray molar pre left',
  xRayMolarPreRight: 'X-Ray molar pre right',
  xRayMolarRight: 'X-Ray molar right',
  xRayPanoramic: 'X-Ray panoramic',
}

export let PATIENT_IMAGE_ASPECT_RATIO = {
  buccalCenter: '3:2',
  buccalLeft: '3:2',
  buccalRight: '3:2',
  facialFrontal: '1:1',
  facialFrontalSmiling: '1:1',
  facialLateral: '1:1',
  occlusalLower: '3:2',
  occlusalUpper: '3:2',
  xRayCephalometric: '299:331',
  xRayMolarLeft: '1:1',
  xRayMolarPreLeft: '1:1',
  xRayMolarPreRight: '1:2',
  xRayMolarRight: '1:1',
  xRayPanoramic: '299:132',
}

export let APPOINTMENT_TYPE_COLORS = {
  'color-A3': '#FF5C33', // Red
  'color-E3': '#9DD600', // Green
  'color-I3': '#00A4F0', // Blue
  'color-G3': '#00D69A', // Blue/Green
  'color-B2': '#FFA552', // Orange
  'color-B1': '#FFC28A', // Light Orange
  'color-B3': '#FF881A', // Dark Orange
  'color-M3': '#FF4CAF', // Pink/Purple
  'color-A0': '#FFEFEB', // Light Pink
  'color-L3': '#C44CFF', // Dark Purple
  'color-K2': '#C3ADFF', // Light Purple
  'color-A5': '#FFB6A3', // Salmon
  'color-brown': '#964B00', // Brown
  'color-light-brown': '#C4A484', // Light Brown
  'color-F3': '#00D600', // Dark Green
  'color-E0': '#D2FF58', // Light Green
  'color-J3': '#668FFF', // Dark Blue
  'color-light-grey': '#D3D3D3', // Light Grey
  'color-dark-grey': '#606060', // Dark Grey
  'color-D2': '#F4F70A', // Yellow
  'color-J0': '#C9C9C9', // White
  'color-black': '#000000', // Black,
  'color-C3': '#DEA708', // Dark Yellow
  'color-I1': '#45BBFF', // Light Blue
  'color-K3': '#7B48FE', // Purple
}

export let APPOINTMENT_TYPE_BG_COLORS = {
  'color-A3': '#FFD6CC', // Red
  'color-E3': '#E7F5BF', // Green
  'color-I3': '#BFE8FB', // Blue
  'color-G3': '#CAF4E6', // Blue/Green
  'color-B2': '#FFE4CB', // Orange
  'color-B1': '#FFF0E2', // Light Orange
  'color-B3': '#FFE1C6', // Dark Orange
  'color-M3': '#FFD2EB', // Pink/Purple
  'color-A0': '#FFF7F5', // Light Pink
  'color-L3': '#F0D2FF', // Dark Purple
  'color-K2': '#F0EBFF', // Light Purple
  'color-A5': '#FFEDE8', // Salmon
  'color-brown': '#E5D2BF', // Brown
  'color-light-brown': '#F0E8E0', // Light Brown
  'color-F3': '#BFF5BF', // Dark Green
  'color-E0': '#F1FFCD', // Light Green
  'color-J3': '#D9E3FF', // Dark Blue
  'color-light-grey': '#F2F2F2', // Light Grey
  'color-dark-grey': '#D7D7D7', // Dark Grey
  'color-D2': '#FCFDB5', // Yellow
  'color-J0': '#FFFFFF', // White
  'color-black': '#D9D9D9', // Black,
  'color-C3': '#F7E9C1', // Dark Yellow
  'color-I1': '#D0EEFF', // Light Blue
  'color-K3': '#DED1FF', // Purple
}

export let TREATMENT_COLORS = {
  RED: 'color-A3',
  GREEN: 'color-E3',
  BLUE: 'color-I3',
  BLUE_GREEN: 'color-G3',
  ORANGE: 'color-B2',
  LIGHT_ORANGE: 'color-B1',
  DARK_ORANGE: 'color-B3',
  PINK_PURPLE: 'color-M3',
  LIGHT_PINK: 'color-A0',
  DARK_PURPLE: 'color-L3',
  LIGHT_PURPLE: 'color-K2',
  SALMON: 'color-A5',
  BROWN: 'color-brown',
  LIGHT_BROWN: 'color-light-brown',
  DARK_GREEN: 'color-F3',
  LIGHT_GREEN: 'color-E0',
  DARK_BLUE: 'color-J3',
  LIGHT_BLUE: 'color-I1',
  LIGHT_GREY: 'color-light-grey',
  DARK_GREY: 'color-dark-grey',
  YELLOW: 'color-D2',
  WHITE: 'color-J0',
  BLACK: 'color-black',
}

export let TREATMENT_FLOW_STEPS = [
  'plan',
  'sign',
  'down_payment',
  'auto_pay',
  'schedule',
]
export let TREATMENT_AUTODRAFT_METHODS = ['bank_account', 'credit_card']
export let TREATMENT_DOWNPAYMENT_METHODS = [
  'in_office',
  'bank_account',
  'credit_card',
]
export let TREATMENT_FLOW_ACCESS_FLAG = 'treatment.flow.enabled'
export let TREATMENT_FLOW_PAYMENT_METHOD_FLAG = 'treatment.flow.payment_method'
export let TREATMENT_PAYMENT_PLAN_VALUE_TYPES = ['amount', 'percentage']
export let TREATMENT_PAYMENT_PLAN_LENGTH_TYPES = ['total', 'relative']
export let TREATMENT_PAYMENT_PLAN_FREQUENCY_TYPES = [
  'None',
  'Monthly',
  'TwicePerMonth',
  'Weekly',
  'EverySecondWeek',
]

export let MEDICAL_HISTORY_CATEGORY_NAME = {
  all: 'All',
  general: 'General',
  medical_conditions: 'Medical conditions',
  habits: 'Habits',
  medications: 'Medications',
  drugs_allergies_and_sensitivities: 'Drug allergies & sensitivities',
  substances: 'Substances',
}

// Medical History fixed questions

export let MANUAL_EVENT_TYPES = {
  appointment_marked_unseated: 'appointment_marked_unseated',
  appointment_marked_checked_out: 'appointment_marked_checked_out',
  treatment_status_changed: 'treatment_status_changed',
}

export let RELATIONSHIPS = [
  {
    id: 'MOTHER',
    text: 'Mother',
    FEMALE: 'CHILD',
    MALE: 'CHILD',
    UNSPECIFIED: 'CHILD',
  },
  {
    id: 'FATHER',
    text: 'Father',
    FEMALE: 'CHILD',
    MALE: 'CHILD',
    UNSPECIFIED: 'CHILD',
  },
  {
    id: 'BROTHER',
    text: 'Brother',
    FEMALE: 'SISTER',
    MALE: 'BROTHER',
    UNSPECIFIED: 'SIBLING',
  },
  {
    id: 'SISTER',
    text: 'Sister',
    FEMALE: 'SISTER',
    MALE: 'BROTHER',
    UNSPECIFIED: 'SIBLING',
  },
  {
    id: 'SIBLING',
    text: 'Sibling',
    FEMALE: 'SIBLING',
    MALE: 'SIBLING',
    UNSPECIFIED: 'SIBLING',
  },
  {
    id: 'GRANDMOTHER',
    text: 'Grandmother',
    FEMALE: 'GRANDDAUGHTER',
    MALE: 'GRANDSON',
    UNSPECIFIED: 'GRANDCHILD',
  },
  {
    id: 'GRANDFATHER',
    text: 'Grandfather',
    FEMALE: 'GRANDDAUGHTER',
    MALE: 'GRANDSON',
    UNSPECIFIED: 'GRANDCHILD',
  },
  {
    id: 'PARTNER',
    text: 'Partner',
    FEMALE: 'PARTNER',
    MALE: 'PARTNER',
    UNSPECIFIED: 'PARTNER',
  },
  {
    id: 'SPOUSE',
    text: 'Spouse',
    FEMALE: 'SPOUSE',
    MALE: 'SPOUSE',
    UNSPECIFIED: 'SPOUSE',
  },
  {
    id: 'STEPMOTHER',
    text: 'Stepmother',
    FEMALE: 'STEPCHILD',
    MALE: 'STEPCHILD',
    UNSPECIFIED: 'STEPCHILD',
  },
  {
    id: 'STEPFATHER',
    text: 'Stepfather',
    FEMALE: 'STEPCHILD',
    MALE: 'STEPCHILD',
    UNSPECIFIED: 'STEPCHILD',
  },
  {
    id: 'GUARDIAN',
    text: 'Guardian',
    FEMALE: 'WARD',
    MALE: 'WARD',
    UNSPECIFIED: 'WARD',
  },
  {
    id: 'WARD',
    text: 'Ward',
    FEMALE: 'GUARDIAN',
    MALE: 'GUARDIAN',
    UNSPECIFIED: 'GUARDIAN',
  },
  {
    id: 'AUNT',
    text: 'Aunt',
    FEMALE: 'NIECE',
    MALE: 'NEPHEW',
    UNSPECIFIED: 'NEPHEW_OR_NIECE',
  },
  {
    id: 'UNCLE',
    text: 'Uncle',
    FEMALE: 'NIECE',
    MALE: 'NEPHEW',
    UNSPECIFIED: 'NEPHEW_OR_NIECE',
  },
  {
    id: 'CHILD',
    text: 'Child',
    FEMALE: 'MOTHER',
    MALE: 'FATHER',
    UNSPECIFIED: 'PARENT',
  },
  {
    id: 'NEPHEW',
    text: 'Nephew',
    FEMALE: 'AUNT',
    MALE: 'UNCLE',
    UNSPECIFIED: 'UNCLE_OR_AUNT',
  },
  {
    id: 'NIECE',
    text: 'Niece',
    FEMALE: 'AUNT',
    MALE: 'UNCLE',
    UNSPECIFIED: 'UNCLE_OR_AUNT',
  },
  {
    id: 'GRANDSON',
    text: 'Grandson',
    FEMALE: 'GRANDMOTHER',
    MALE: 'GRANDFATHER',
    UNSPECIFIED: 'GRANDPARENT',
  },
  {
    id: 'GRANDDAUGHTER',
    text: 'Granddaughter',
    FEMALE: 'GRANDMOTHER',
    MALE: 'GRANDFATHER',
    UNSPECIFIED: 'GRANDPARENT',
  },
  {
    id: 'STEPCHILD',
    text: 'Stepchild',
    FEMALE: 'STEPMOTHER',
    MALE: 'STEPFATHER',
    UNSPECIFIED: 'STEPPARENT',
  },
  {
    id: 'OTHER',
    text: 'Other',
    FEMALE: 'OTHER',
    MALE: 'OTHER',
    UNSPECIFIED: 'OTHER',
  },
]

export let TEMPORARY_IMAGE_PREFIX = 'tmpimg'
export let PATIENT_IMAGE_PREFIX = 'patientimg'
export let PATIENT_ORIGINAL_IMAGE_PREFIX = 'orig_patientimg'

export let DAYS = [
  { id: 'monday', text: 'Monday' },
  { id: 'tuesday', text: 'Tuesday' },
  { id: 'wednesday', text: 'Wednesday' },
  { id: 'thursday', text: 'Thursday' },
  { id: 'friday', text: 'Friday' },
  { id: 'saturday', text: 'Saturday' },
  { id: 'sunday', text: 'Sunday' },
]

// copied from functions/helpers/payments.js
export let PAYMENTS_PAYMENT_TYPES = /** @type {const} */ ({
  AutoPayment: 'AutoPayment',
  BankAccountPayment: 'BankAccountPayment',
  CashPayment: 'CashPayment',
  CheckPayment: 'CheckPayment',
  CreditCardPayment: 'CreditCardPayment',
  /**
   * @description this one is just used to control execution flow, it will be inserted as CreditCardPayment
   */
  CreditCardManualPayment: 'CreditCardManualPayment',
  InsurancePayment: 'InsurancePayment',
  OtherPayment: 'OtherPayment',
  TransferPayment: 'TransferPayment',
  // Payabli/UI only
  PaymentPagePayment: 'PaymentPagePayment',
})

export let PAYMENT_ACCOUNT_TYPES = /** @type {const} */ ({
  Person: 'PersonPaymentAccount',
  Insurance: 'InsurancePaymentAccount',
})

// copied from functions/helpers/payments.js
export let PAYMENT_PLAN_TYPES = /** @type {const} */ ({
  Person: 'Person',
  Insurance: 'Insurance',
})

// based on sources/core-embed/core-embed-application/src/main/java/com/axpm/modules/admin/businessportal/ui/paymenttypes/PaymentTypeType.java
export let PAYMENT_TYPE_INT_TO_PAYMENTS_PAYMENT_TYPE = /** @type {const} */ {
  1: PAYMENTS_PAYMENT_TYPES.CashPayment,
  2: PAYMENTS_PAYMENT_TYPES.CheckPayment,
  3: PAYMENTS_PAYMENT_TYPES.CreditCardPayment,
  4: PAYMENTS_PAYMENT_TYPES.CreditCardManualPayment,
  5: PAYMENTS_PAYMENT_TYPES.OtherPayment,
  6: PAYMENTS_PAYMENT_TYPES.BankAccountPayment,
}

// copied from functions/helpers/payments.js
export let PAYMENT_PLAN_AUTOPAY_SOURCES = /** @type {const} */ ({
  BankAccount: 'BankAccount',
  CreditCard: 'CreditCard',
})

export let NOTE_TEMPLATE_EDITOR_VARIANTS = /** @type {const} */ ({
  richtext: 'richtext',
  plaintext: 'plaintext',
})

export let TRANSACTION_TYPES = /** @type {const} */ ({
  LateFeeCharge: 'LateFeeCharge',
  MiscFeeCharge: 'MiscFeeCharge',
  RetailFeeCharge: 'RetailFeeCharge',
  TxFeeCharge: 'TxFeeCharge',
  DiscountAdjustment: 'DiscountAdjustment',
  WriteOff: 'WriteOff',
  FixAdjustment: 'FixAdjustment',
  MigrationFixAdjustment: 'MigrationFixAdjustment',
  Payment: 'payment',
  PaymentPlan: 'PaymentPlan',
  ChargeTransfer: 'ChargeTransfer',
  TransferCharge: 'TransferCharge',
  InstallmentCharge: 'InstallmentCharge',
})

/**
 * @type {Record<string, { name: string; editorVariant: typeof NOTE_TEMPLATE_EDITOR_VARIANTS[keyof typeof NOTE_TEMPLATE_EDITOR_VARIANTS] }>}
 */
export let NOTE_TEMPLATE_TAGS = {
  appointment: {
    name: 'Appointment card notes',
    editorVariant: 'richtext',
  },
  comms: {
    name: 'Comms',
    editorVariant: 'plaintext',
  },
}

/** @readonly */
export let MONTHS = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
].map((month, index) => ({ id: index, text: month }))

export let DEFAULT_TIMEZONE = 'America/Chicago'

export let GENDERS = [
  {
    id: 'MALE',
    text: 'Male',
  },
  {
    id: 'FEMALE',
    text: 'Female',
  },
  {
    id: 'UNSPECIFIED',
    text: 'Unspecified',
  },
]

export let SUPPORTED_PAYMENT_METHODS = /** @type {const} */ ({
  wisetack: {
    id: 'wisetack',
    payment_plan: {
      name: 'Pay over time with Wisetack',
      description: 'Pay in installments',
      downpayment: 100,
      downpayment_type: 'percentage',
      length: 0,
      length_type: 'total',
      frequency: 'None',
      order: 0,
      discounts: {
        data: [],
      },
    },
  },
  hfd: {
    id: 'hfd',
    payment_plan: {
      name: 'Apply to pay over time with HFD Financing',
      description:
        'Available offers are subject to approval and credit qualification',
      downpayment: 100,
      downpayment_type: 'percentage',
      length: 0,
      length_type: 'total',
      frequency: 'None',
      order: 0,
      discounts: {
        data: [],
      },
    },
  },
})

export let BOOKING_STATES = /** @type {const} */ ({
  NO_SHOW: 'NO_SHOW',
  PATIENT_CANCELLED: 'PATIENT_CANCELLED',
  OFFICE_CANCELLED: 'OFFICE_CANCELLED',
})

export let UNSCHEDULED_BOOKING_STATES = /** @type {const} */ ([
  BOOKING_STATES.NO_SHOW,
  BOOKING_STATES.OFFICE_CANCELLED,
  BOOKING_STATES.PATIENT_CANCELLED,
])

export let CONNECTION_STATUSES = /** @type {const} */ ({
  ACTIVE: 'active',
  INACTIVE: 'inactive',
  ERROR: 'error',
  ERROR_REFRESH: 'error_refresh',
  EXPIRED: 'expired',
})

export let INACTIVE_CONNECTION_STATUSES = /** @type {const} */ ([
  CONNECTION_STATUSES.INACTIVE,
  CONNECTION_STATUSES.ERROR,
  CONNECTION_STATUSES.ERROR_REFRESH,
  CONNECTION_STATUSES.EXPIRED,
])

export let TASK_BOARD_ICONS = /** @type {const} */ ([
  {
    id: 'FACDCD',
    text: '#FACDCD',
    background: '#FACDCD',
    color: '#780A0A',
    icon: 'Tysiav2BoardsClipboardIcon',
  },
  {
    id: 'FAE0CD',
    text: '#FAE0CD',
    background: '#FAE0CD',
    color: '#743609',
    icon: 'Tysiav2BoardsClipboardIcon',
  },
  {
    id: 'FCEFC7',
    text: '#FCEFC7',
    background: '#FCEFC7',
    color: '#7C5E0F',
    icon: 'Tysiav2BoardsClipboardIcon',
  },
  {
    id: 'CFBCF2',
    text: '#CFBCF2',
    background: '#CFBCF2',
    color: '#34126F',
    icon: 'Tysiav2BoardsClipboardIcon',
  },
  {
    id: 'EEBCF2',
    text: '#EEBCF2',
    background: '#EEBCF2',
    color: '#5C0C62',
    icon: 'Tysiav2BoardsClipboardIcon',
  },
  {
    id: 'C7D0F0',
    text: '#C7D0F0',
    background: '#C7D0F0',
    color: '#0E1F5C',
    icon: 'Tysiav2BoardsClipboardIcon',
  },
  {
    id: 'C1EAC5',
    text: '#C1EAC5',
    background: '#C1EAC5',
    color: '#0E5814',
    icon: 'Tysiav2BoardsClipboardIcon',
  },
  {
    id: 'B7DCF6',
    text: '#B7DCF6',
    background: '#B7DCF6',
    color: '#0E3958',
    icon: 'Tysiav2BoardsClipboardIcon',
  },
  {
    id: 'F8CAD7',
    text: '#F8CAD7',
    background: '#F8CAD7',
    color: '#7A0C2B',
    icon: 'Tysiav2BoardsClipboardIcon',
  },
  {
    id: 'CFBCF2Tysiav2MedicalTaskIcon',
    text: '#CFBCF2',
    background: '#CFBCF2',
    color: '#34126F',
    icon: 'Tysiav2MedicalTaskIcon',
  },
  {
    id: 'EEBCF2Tysiav2ClockInTaskIcon',
    text: '#EEBCF2',
    background: '#EEBCF2',
    color: '#34126F',
    icon: 'Tysiav2ClockInTaskIcon',
  },
  {
    id: 'C7D0F0Tysiav2LetterTaskIcon',
    text: '#C7D0F0',
    background: '#C7D0F0',
    color: '#0E1F5C',
    icon: 'Tysiav2LetterTaskIcon',
  },
  {
    id: 'C1EAC5Tysiav2PatientTaskIcon',
    text: '#C1EAC5',
    background: '#C1EAC5',
    color: '#0E5814',
    icon: 'Tysiav2PatientTaskIcon',
  },
  {
    id: 'B7DCF6Tysiav2ImageTaskIcon',
    text: '#B7DCF6',
    background: '#B7DCF6',
    color: '#0E3958',
    icon: 'Tysiav2ImageTaskIcon',
  },
  {
    id: 'F8CAD7Tysiav2MedicalHistoryTaskIcon',
    text: '#F8CAD7',
    background: '#F8CAD7',
    color: '#7A0C2B',
    icon: 'Tysiav2MedicalHistoryTaskIcon',
  },
  {
    id: 'FACDCDTysiav2FinanceTaskIcon',
    text: '#FACDCD',
    background: '#FACDCD',
    color: '#780A0A',
    icon: 'Tysiav2FinanceTaskIcon',
  },
])

export let TASK_PRIORITIES = /** @type {const} */ ([
  {
    id: 'low',
    text: 'Low',
  },
  {
    id: 'medium',
    text: 'Medium',
  },
  {
    id: 'high',
    text: 'High',
  },
  {
    id: 'urgent',
    text: 'Urgent',
  },
])

export let TASK_PRIORITIES_ORDER = /** @type {const} */ ({
  URGENT: {
    label: 'urgent',
    order: 4,
  },
  HIGH: {
    label: 'high',
    order: 3,
  },
  MEDIUM: {
    label: 'medium',
    order: 2,
  },
  LOW: {
    label: 'low',
    order: 1,
  },
})

export let UNTEMPLATED_SCHEDULING_ALLOWED_TYPE_OVERLAPS =
  /** @type {const} */ ([
    'candidate-shadow',
    'candidate-untemplated',
    'candidate-untemplated-hover',
    'note',
    'closed',
    'appointment-type',
    'appointment-type-candidate',
  ])

export let FULL_DAY_VIEW_INTERVAL = 30

export let FEE_MODE = /** @type {const} */ ({
  STANDARD: 'STANDARD',
  PLATFORM_FEE: 'PLATFORM_FEE',
  SURCHARGE: 'SURCHARGE',
})

export let FEE_MODE_RANGES = /** @type {const} */ ({
  [FEE_MODE.PLATFORM_FEE]: {
    CARD: {
      MIN: 2.79,
      DEFAULT: 2.79,
      MAX: 5,
    },
    ACH: {
      MIN: 0,
      DEFAULT: 1,
      MAX: 5,
    },
  },
  [FEE_MODE.SURCHARGE]: {
    CARD: {
      MIN: 0,
      DEFAULT: 1,
      MAX: 5,
    },
  },
})

export let LOCAL_STORAGE_FREQUENT_VALUES = 'frequently_used_values'
export let FREQUENTLY_USED_VALUE_KEYS = /** @type {const} */ ({
  TASK_ASSIGNEES: 'task_assignees',
})

export let TASK_AUDIT_LOG_TYPES = /** @type {const} */ ({
  TASK_CREATED: 'TASK_CREATED',
  TASK_MOVED: 'TASK_MOVED',
  TASK_PRIORITY_CHANGED: 'TASK_PRIORITY_CHANGED',
  TASK_DONE: 'TASK_DONE',
  TASK_TITLE_CHANGED: 'TASK_TITLE_CHANGED',
  TASK_DESCRIPTION_CHANGED: 'TASK_DESCRIPTION_CHANGED',
  TASK_DUEDATE_CHANGED: 'TASK_DUEDATE_CHANGED',
  TASK_PATIENT_CHANGED: 'TASK_PATIENT_CHANGED',
  // event on tasks.comments
  TASK_COMMENT_ADDED: 'TASK_COMMENT_ADDED',
  // event on tasks.assignees
  TASK_ASSIGNED: 'TASK_ASSIGNED',
  // event on tasks.resources
  TASK_LETTER_GENERATED: 'TASK_LETTER_GENERATED',
  TASK_LETTER_REGENERATED: 'TASK_LETTER_REGENERATED',
  // event on tasks_tags
  TASK_TAG_ADDED: 'TASK_TAG_ADDED',
  TASK_TAG_REMOVED: 'TASK_TAG_REMOVED',
})

export let APPS_LAUNCHERS_TYPES = /** @type {const} */ ({
  URL_STATIC: 'URL_STATIC',
  URL_HTTP: 'URL_HTTP',
  ACTION_QR: 'ACTION_QR',
  ACTION_HTTP: 'ACTION_HTTP',
  ACTION_COMPONENT: 'ACTION_COMPONENT',
  ACTION_EXTERNAL_MAPPING_REMOVE: 'ACTION_EXTERNAL_MAPPING_REMOVE',
})

export let LAUNCHER_DISPLAY_FORMATS = /** @type {const} */ ({
  MODAL_FULLSCREEN: 'MODAL_FULLSCREEN',
  NEW_WINDOW: 'NEW_WINDOW',
})

export let MULTIPLE_CONNECTIONS_FOUND = /** @type{const} */ (
  'multiple_connections_found'
)

/**
 * Average calendar month length
 * 365 (days in a year) / 7 (days in a week) / 12 (months in a year) = 4.34524
 */
export let WEEKS_PER_MONTH = /** @type{const} */ 4.34524
